'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditController = function () {
  function EditController(ImagesDataProvider, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EditController);
    this.ImagesDataProvider = ImagesDataProvider;
    this.$state = $state;
    var vm = this;
    vm.ImagesDataProvider.getCategoryById(vm.$state.params.id).then(function (result) {
      vm.category = result;
    });
  }

  (0, _createClass3.default)(EditController, [{
    key: 'update',
    value: function update(form) {
      if (!form) {
        return false;
      }
      var vm = this;
      vm.ImagesDataProvider.updateCategory(vm.category).then(function (res) {
        if (res.exist == '1') {
          vm.existRecord = 1;
        } else {
          vm.$state.go('app.imageCategories');
        }
      });
    }
  }]);
  return EditController;
}();

// WEBPACK FOOTER //


exports.default = EditController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/images/components/category_edit/controller.js
 **/